import type { CSSProperties, ReactNode } from 'react';
import { UMIcon } from '../../urbanmap/_components';
import { PLAN, UMR } from './planTokens';

/** Primitives visuelles utilisées par la V3, copiées depuis proposition-c/ui. */
export function PlanLogo({ size = 40 }: { size?: number }) {
  return (
    <div
      aria-label="Plan"
      style={{
        width: size, height: size, background: PLAN.accent, color: UMR.white, fontWeight: 700,
        fontSize: size > 36 ? 13 : 11, display: 'flex', alignItems: 'center', justifyContent: 'center', letterSpacing: 0.3, flexShrink: 0,
      }}
    >
      Plan
    </div>
  );
}

export function Pill({ children, tone = 'accent', icon, title, onClick }: {
  children: ReactNode; tone?: 'accent' | 'warning' | 'neutral' | 'success' | 'scenario'; icon?: string; title?: string; onClick?: () => void;
}) {
  const palette = {
    accent: { bg: PLAN.accentBg, fg: PLAN.accentStrong, bd: PLAN.accentBorder },
    warning: { bg: PLAN.warningBg, fg: PLAN.warningText, bd: PLAN.warningBorder },
    neutral: { bg: UMR.grey100, fg: UMR.textSecondary, bd: UMR.border },
    success: { bg: PLAN.successBg, fg: PLAN.successText, bd: 'transparent' },
    scenario: { bg: 'var(--nj-core-color-purple-100, #f1eafb)', fg: 'var(--nj-core-color-purple-800, #4d2391)', bd: 'transparent' },
  }[tone];
  const style: CSSProperties = {
    display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 8px', borderRadius: 12, fontSize: 12, lineHeight: '18px',
    background: palette.bg, color: palette.fg, border: `1px solid ${palette.bd}`, fontFamily: UMR.font, whiteSpace: 'nowrap',
    cursor: onClick ? 'pointer' : 'default',
  };
  const content = (
    <>
      {icon && <UMIcon name={icon} size={14} color={palette.fg} />}
      {children}
    </>
  );
  return onClick ? <button type="button" title={title} onClick={onClick} style={style}>{content}</button> : <span title={title} style={style}>{content}</span>;
}

export function Toast({ children }: { children: ReactNode }) {
  return (
    <div
      role="status"
      style={{
        position: 'absolute', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 120,
        background: UMR.textStrong, color: UMR.white, padding: '10px 16px', fontSize: 14, fontFamily: UMR.font, boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
        display: 'flex', alignItems: 'center', gap: 8, maxWidth: 560,
      }}
    >
      <UMIcon name="info" size={18} color={UMR.white} />
      {children}
    </div>
  );
}
